import { gql } from "@apollo/client";

export const GET_UNITS = gql`
  query Units($where: UnitWhereInput) {
    units(where: $where) {
      data {
        id
        name
        status
        isDeleted
        createdAt
        updatedAt
        shop {
          id
        }
      }
      total
    }
  }
`;
